import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface AiCreatorProtectedRouteProps {
  children: ReactNode;
}

export function AiCreatorProtectedRoute({ children }: AiCreatorProtectedRouteProps) {
  const { user, userRole, userRoleData, isLoading } = useAuth();

  if (isLoading || (user && userRole === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  const isAiCreator = userRole === "employee" && userRoleData?.employee_type === "ai_creator";
  const isAdmin = userRole === "admin";

  if (!isAiCreator && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
